import React, { useState } from "react";
import { Table, Select, Button, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styles from "./ProcessMgmt.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../assets/images/actionicon.svg";
import { Modal, SubmitButton, TextComponent } from "../../../components";
import HeaderComponent from "../../../components/HeaderComponent/HeaderComponent";

import { ReactComponent as ViewIcon } from "../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../assets/images/editIcon.svg";
const { Option } = Select;

const ProcessManagement = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
    },

    {
      title: "Process Code",
      dataIndex: "ProcessCode",
      key: "ProcessCode",
    },
    {
      title: "Process Name",
      key: "ProcessName",
      dataIndex: "ProcessName",
    },
    // {
    //   title: "Station",
    //   key: "Station",
    //   dataIndex: "Station",
    // },
    {
      title: "Action",
      key: "Action",
      dataIndex: "Action",
      render: (text) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() =>
              navigate(
                "/ProductionManagement/ProcessManagement/InstructionSetup/Summary"
              )
            }
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/ProductionManagement/ProcessBuilder")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      ProcessCode: "MAT-000",
      ProcessName: "Flour Dough",
      Station: "Mixing",

      // Station: "Mixing",
      Action: "View",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "2",
      ProcessCode: "MAT-003",
      ProcessName: "Ferment Flow",
      Station: "Proof",

      // Station: "Proof",
      Action: "Edit",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "3",
      ProcessCode: "MAT-001",
      ProcessName: "Dough Design",
      Station: "Makeup",

      // Station: "Makeup",
      Action: "Delete",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "4",
      ProcessCode: "MAT-004",
      ProcessName: "Fresh Keep",
      Station: "Chill",

      // Station: "Chill",
      Action: "Delete",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "5",
      ProcessCode: "MAT-002",
      ProcessName: "Blend",
      Station: "Mixing",

      // Station: "Mixing",
      Action: "View",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "6",
      ProcessCode: "MAT-005",
      ProcessName: "Bake to Box",
      Station: "Packaging",

      // Station: "Packaging",
      Action: "View",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "7",
      ProcessCode: "MAT-006",
      ProcessName: "Loft Stage",
      Station: "Proof",

      // Station: "Proof",
      Action: "Edit",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "8",
      ProcessCode: "MAT-007",
      ProcessName: "Fresh Lock",
      Station: "Packaging",

      // Station: "Packaging",
      Action: "Delete",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
    {
      No: "9",
      ProcessCode: "MAT-008",
      ProcessName: "Harmony Mix",
      Station: "Mixing",

      // Station: "Mixing",
      Action: "View",
      Button: (
        <SubmitButton
          title={"Continue"}
          primary
          btnClass={styles.actionBtn}
          // onClick={handleSubmit}
        />
      ),
    },
  ];

  return (
    <div className={styles.mainCont}>
      {/* Heading Section with Right Controls */}
      <HeaderComponent
        heading={"Process Management"}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/ProductionManagement/ProcessBuilder")}
        submitButtonText={"Create New Process"}
        // showBackIcon={true}
        showFilterIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      {/* Table Section */}
      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        twoButton
        cancelBtnTitle={"No"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        onBtnPress={() => setIsModal(false)}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ProcessManagement;
